/** @jsxImportSource preact */

interface CheckoutLinkProps {
  onOpen: () => void;
  label?: string;
}

/**
 * Inline "open checkout" affordance for the message thread.
 *
 * The actual iframe lifecycle lives in widget.ts (origin pinning,
 * postMessage handshake, prefill) — this component only exposes the
 * action surface so the user can re-open the sheet if it was closed.
 */
export function CheckoutLink({ onOpen, label }: CheckoutLinkProps) {
  return (
    <button
      type="button"
      class="lc-checkout-link"
      onClick={(e) => {
        e.preventDefault();
        onOpen();
      }}
    >
      {label || 'Abrir checkout'}
    </button>
  );
}
